const env = process.env.NODE_ENV;

// Production host  eg: cm.sf-vogt.eskalearning.com
let prod_host_name = window.location.host;
let service_name = "lyceedanakouba";
let apiBaseUrl = "https://cm.sfbe.eskalearning.com/";
if (env !== "production") {
  apiBaseUrl = "https://sandbox.scolarfleet.eskalearning.com";
  // apiBaseUrl = 'http://127.0.0.1:8002'
} else {
  const service = prod_host_name.split(".")[1];
  service_name = service.split("-")[1];
  apiBaseUrl = apiBaseUrl + service_name;
}

const api_config = {
  PHONE_PREFIX:localStorage.getItem("callingCode"),
  COUNTRY_FLAG:localStorage.getItem("country_flag"),
  PHONE_MAX_LENGTH: 9,
  API_ENDPOINT: apiBaseUrl,
  SERVICE_NAME: service_name,
  TOKEN_ESKA:localStorage.getItem("eska_api_token"),
  TOKEN_XSCHOOLPAY:localStorage.getItem("xpay_api_token"),
  ESKA_API_URL:localStorage.getItem("eska_api_url"),
  XPAY_API_URL:localStorage.getItem("xpay_api_url"),
  SF_WEB_API_URL:localStorage.getItem("sf_web_api_url"),
  CURRENCY_CODE:localStorage.getItem("currencyCode"),
  SETTLED: "Settled",
  ACCEPTED: "Accepted",
  OVERDUE: "Overdue",
  PENDING: "Pending",
  PAID: "Paid",
  PAYMENT_TYPE:"SchoolFees",
  MIN_TRANSFER_AMOUNT: "MIN_TRANSFER_AMOUNT",
  ALLOW_SPLIT_PAYMENT: "ALLOW_SPLIT_PAYMENT",
  FEES_ON_PAYER: "FEES_ON_PAYER",
  UPDATE_BANK_INFORMATION: "UPDATE_BANK_INFO",
  COUNTRY_CODE:"CM",
  LINK_TO_SHARE:"https://www.eskalearning.com/download?src=sk",
  MIN_TRANSFER_AMOUNT_TITLE : "min transfer amount",
  ALLOW_SPLIT_PAYMENT_TILTLE : "allow split payment",
  FEES_ON_PAYER_TITLE : "fees on payer",
  UPDATE_BANK_INFORMATION_TITLE :"update bank information",
  BANK_TRANSFERS_LATE_TITLE : "bank transfers late",
  INCORRECT_TRANSFER_AMOUNT_TITLE : "incorrect transfer amount",
  BEAR_COSTS:"I want to support the fees",
  NO_BEAR_COSTS:"I do not want to support the fees",
  NO_SPLIT_PAYEMENT : "I want to disable split  payment",
  SPLIT_PAYEMENT : "I want to enable split  payment",
  PROMOTE : "Promote",
  REAPEAT : "Repeat",
  ENDCYCLE : "EndCycle",
  DOWNGRADE : "Downgrade",
};
export default api_config;